var map = {
	"./components/App.vue": [
		124
	],
	"./components/chartjs/Bar.vue": [
		647,
		71
	],
	"./components/chartjs/Line.vue": [
		648,
		70
	],
	"./components/global/Action.vue": [
		89
	],
	"./components/global/Bubble.vue": [
		280
	],
	"./components/global/ButtonBack.vue": [
		281
	],
	"./components/global/Calendar.vue": [
		282
	],
	"./components/global/ChannelList.vue": [
		283
	],
	"./components/global/ChannelListGroup.vue": [
		284
	],
	"./components/global/ChannelListSingle.vue": [
		286
	],
	"./components/global/Chat.vue": [
		287
	],
	"./components/global/ChatBubble.vue": [
		288
	],
	"./components/global/Chatbox.vue": [
		82
	],
	"./components/global/Confirm.vue": [
		128
	],
	"./components/global/Container.vue": [
		289
	],
	"./components/global/DatePickerModal.vue": [
		763,
		87
	],
	"./components/global/Dates.vue": [
		290
	],
	"./components/global/Dropdown.vue": [
		291
	],
	"./components/global/Error.vue": [
		292
	],
	"./components/global/Flash.vue": [
		126
	],
	"./components/global/FooterBar.vue": [
		293
	],
	"./components/global/Gravatar.vue": [
		294
	],
	"./components/global/GravatarGroup.vue": [
		295
	],
	"./components/global/Icon.vue": [
		296
	],
	"./components/global/ItemChatbox.vue": [
		297
	],
	"./components/global/Lesson.vue": [
		132
	],
	"./components/global/Loader.vue": [
		129
	],
	"./components/global/LoginAside.vue": [
		139
	],
	"./components/global/MainContent.vue": [
		298
	],
	"./components/global/MainHeader.vue": [
		136
	],
	"./components/global/Modal.vue": [
		125
	],
	"./components/global/Notes.vue": [
		299
	],
	"./components/global/Notification.vue": [
		130
	],
	"./components/global/Numeric.vue": [
		300
	],
	"./components/global/Percents.vue": [
		301
	],
	"./components/global/Pikaday.vue": [
		90
	],
	"./components/global/Presence.vue": [
		649,
		232
	],
	"./components/global/Profile.vue": [
		302
	],
	"./components/global/Rangepicker.vue": [
		304
	],
	"./components/global/Search.vue": [
		305
	],
	"./components/global/Selection.vue": [
		306
	],
	"./components/global/Sidebar.vue": [
		307
	],
	"./components/global/SubHeader.vue": [
		308
	],
	"./components/global/Tab.vue": [
		309
	],
	"./components/global/Tabs.vue": [
		310
	],
	"./components/global/Timeframe.vue": [
		311
	],
	"./components/global/Timepicker.vue": [
		312
	],
	"./components/global/Toolbox.vue": [
		313
	],
	"./components/global/Tools.vue": [
		314
	],
	"./components/global/Tooltip.vue": [
		133
	],
	"./components/global/University.vue": [
		131
	],
	"./components/global/Widget.vue": [
		127
	],
	"./components/global/dashboard/Card.vue": [
		330
	],
	"./components/global/dashboard/Filter.vue": [
		644,
		231
	],
	"./components/global/dashboard/OpenApplications.vue": [
		656,
		36
	],
	"./components/global/dashboard/OpenItems.vue": [
		657,
		69
	],
	"./components/global/tools/Conflicts.vue": [
		317
	],
	"./components/global/tools/Duty.vue": [
		320
	],
	"./components/global/tools/Employee.vue": [
		326
	],
	"./components/global/tools/Flags.vue": [
		325
	],
	"./components/global/tools/Internal.vue": [
		316
	],
	"./components/global/tools/NewDuty.vue": [
		328
	],
	"./components/global/tools/NewShift.vue": [
		327
	],
	"./components/global/tools/NewUser.vue": [
		329
	],
	"./components/global/tools/Notes.vue": [
		315
	],
	"./components/global/tools/Project.vue": [
		324
	],
	"./components/global/tools/Shift.vue": [
		319
	],
	"./components/global/tools/Sick.vue": [
		323
	],
	"./components/global/tools/Tags.vue": [
		322
	],
	"./components/global/tools/Times.vue": [
		318
	],
	"./components/global/tools/User.vue": [
		321
	],
	"./components/modals/AbsenceRegistration.vue": [
		658,
		86
	],
	"./components/modules/Navigation.vue": [
		137
	],
	"./components/modules/SubNavigation.vue": [
		659,
		230
	],
	"./components/widgets/addContract.vue": [
		764,
		128
	],
	"./components/widgets/addHours.vue": [
		765,
		229
	],
	"./components/widgets/assignLocations.vue": [
		766,
		85
	],
	"./components/widgets/changeEmail.vue": [
		767,
		228
	],
	"./components/widgets/changePassword.vue": [
		768,
		227
	],
	"./components/widgets/chatParticipants.vue": [
		769,
		226
	],
	"./components/widgets/checkin.vue": [
		770,
		225
	],
	"./components/widgets/checkins.vue": [
		771,
		224
	],
	"./components/widgets/clientProject.vue": [
		772,
		15
	],
	"./components/widgets/clients.vue": [
		773,
		84
	],
	"./components/widgets/contractTemplate.vue": [
		774,
		83
	],
	"./components/widgets/contracts.vue": [
		775,
		82
	],
	"./components/widgets/costs.vue": [
		660,
		223
	],
	"./components/widgets/defaultAvailability.vue": [
		776,
		222
	],
	"./components/widgets/denyHours.vue": [
		777,
		221
	],
	"./components/widgets/duties.vue": [
		778,
		127
	],
	"./components/widgets/employeeNumber.vue": [
		779,
		220
	],
	"./components/widgets/employees.vue": [
		780,
		219
	],
	"./components/widgets/employeesEdit.vue": [
		781,
		126
	],
	"./components/widgets/expenses.vue": [
		782,
		218
	],
	"./components/widgets/holidays.vue": [
		783,
		217
	],
	"./components/widgets/launchDashboard.vue": [
		784,
		216
	],
	"./components/widgets/location.vue": [
		785,
		215
	],
	"./components/widgets/locations.vue": [
		786,
		214
	],
	"./components/widgets/newChat.vue": [
		787,
		213
	],
	"./components/widgets/planningMemberships.vue": [
		788,
		212
	],
	"./components/widgets/planningResources.vue": [
		789,
		211
	],
	"./components/widgets/plannings.vue": [
		790,
		210
	],
	"./components/widgets/premiums.vue": [
		791,
		209
	],
	"./components/widgets/premiumsOverview.vue": [
		792,
		208
	],
	"./components/widgets/profileLocations.vue": [
		793,
		207
	],
	"./components/widgets/projects.vue": [
		794,
		206
	],
	"./components/widgets/rates.vue": [
		795,
		205
	],
	"./components/widgets/report.vue": [
		796,
		125
	],
	"./components/widgets/resources.vue": [
		797,
		204
	],
	"./components/widgets/revenues.vue": [
		798,
		124
	],
	"./components/widgets/salary.vue": [
		799,
		203
	],
	"./components/widgets/shifts.vue": [
		800,
		42
	],
	"./components/widgets/signature.vue": [
		801,
		67
	],
	"./components/widgets/switcher.vue": [
		802,
		202
	],
	"./components/widgets/tags.vue": [
		803,
		201
	],
	"./components/widgets/timechooser.vue": [
		804,
		200
	],
	"./components/widgets/userProfile.vue": [
		805,
		81
	],
	"./pages/availability/Page.vue": [
		806,
		7
	],
	"./pages/availability/components/Sidebar.vue": [
		661,
		123
	],
	"./pages/availability/components/SubHeader.vue": [
		662,
		122
	],
	"./pages/availability/planner/Availability.vue": [
		663,
		41
	],
	"./pages/availability/planner/Cell.new.vue": [
		807,
		121
	],
	"./pages/availability/planner/Cell.vue": [
		650,
		120
	],
	"./pages/availability/user/Availability.vue": [
		664,
		40
	],
	"./pages/availability/user/Cell.vue": [
		651,
		119
	],
	"./pages/balances/details/Page.vue": [
		808,
		34
	],
	"./pages/balances/details/components/Sidebar.vue": [
		665,
		199
	],
	"./pages/balances/details/components/SubHeader.vue": [
		666,
		198
	],
	"./pages/balances/overview/Page.vue": [
		809,
		33
	],
	"./pages/balances/overview/components/Sidebar.vue": [
		667,
		197
	],
	"./pages/balances/overview/components/SubHeader.vue": [
		668,
		196
	],
	"./pages/chats/details/Page.vue": [
		810,
		66
	],
	"./pages/chats/details/components/SubHeader.vue": [
		669,
		195
	],
	"./pages/chats/overview/Page.vue": [
		811,
		65
	],
	"./pages/chats/overview/components/SubHeader.vue": [
		670,
		194
	],
	"./pages/checkins/Page.vue": [
		812,
		10
	],
	"./pages/checkins/components/CheckinTime.vue": [
		673,
		193
	],
	"./pages/checkins/components/Item.vue": [
		652,
		80
	],
	"./pages/checkins/components/Sidebar.vue": [
		672,
		35
	],
	"./pages/checkins/components/SubHeader.vue": [
		671,
		192
	],
	"./pages/clients/overview/Page.vue": [
		813,
		28
	],
	"./pages/clients/overview/components/Sidebar.vue": [
		674,
		118
	],
	"./pages/clients/overview/components/SubHeader.vue": [
		675,
		191
	],
	"./pages/company/Page.vue": [
		814,
		22
	],
	"./pages/contacts/Page.vue": [
		815,
		64
	],
	"./pages/contacts/components/SubHeader.vue": [
		676,
		190
	],
	"./pages/dashboard/Hour.vue": [
		677,
		117
	],
	"./pages/dashboard/Page.vue": [
		816,
		29
	],
	"./pages/demo/Page.vue": [
		817,
		79
	],
	"./pages/documents/detail/Page.vue": [
		818,
		27
	],
	"./pages/documents/detail/components/Sidebar.vue": [
		679,
		116
	],
	"./pages/documents/detail/components/SubHeader.vue": [
		678,
		115
	],
	"./pages/documents/overview/Page.vue": [
		819,
		39
	],
	"./pages/documents/overview/components/Sidebar.vue": [
		820,
		189
	],
	"./pages/documents/overview/components/SubHeader.vue": [
		680,
		188
	],
	"./pages/example.vue": [
		821,
		78
	],
	"./pages/freelancer/Page.vue": [
		822,
		2
	],
	"./pages/freelancer/components/Sidebar.vue": [
		681,
		77
	],
	"./pages/freelancer/components/SubHeader.vue": [
		823,
		187
	],
	"./pages/hours/Page.vue": [
		824,
		14
	],
	"./pages/hours/components/HoursItem.vue": [
		684,
		186
	],
	"./pages/hours/components/Item.vue": [
		825,
		185
	],
	"./pages/hours/components/Sidebar.vue": [
		682,
		184
	],
	"./pages/hours/components/SubHeader.vue": [
		683,
		183
	],
	"./pages/hours/components/tab/biller.vue": [
		826,
		182
	],
	"./pages/hours/components/tab/supervisor.vue": [
		827,
		181
	],
	"./pages/invoice/Page.vue": [
		828,
		180
	],
	"./pages/lists/Page.vue": [
		829,
		3
	],
	"./pages/lists/components/Sidebar.vue": [
		685,
		114
	],
	"./pages/lists/components/SubHeader.vue": [
		686,
		179
	],
	"./pages/log/Page.vue": [
		830,
		26
	],
	"./pages/log/components/Sidebar.vue": [
		687,
		113
	],
	"./pages/log/components/SubHeader.vue": [
		688,
		178
	],
	"./pages/login/2fa-setup/Page.vue": [
		831,
		112
	],
	"./pages/login/2fa-verify/Page.vue": [
		832,
		111
	],
	"./pages/login/accept/Page.vue": [
		833,
		177
	],
	"./pages/login/confirm/Page.vue": [
		834,
		176
	],
	"./pages/login/confirmation/Page.vue": [
		835,
		175
	],
	"./pages/login/password/Page.vue": [
		836,
		174
	],
	"./pages/login/reset/Page.vue": [
		837,
		173
	],
	"./pages/login/signin/Page.vue": [
		838,
		110
	],
	"./pages/login/signup/Page.vue": [
		839,
		172
	],
	"./pages/modules/Page.vue": [
		840,
		19
	],
	"./pages/modules/components/Module.vue": [
		689,
		171
	],
	"./pages/modules/components/Sidebar.vue": [
		690,
		170
	],
	"./pages/modules/components/SubHeader.vue": [
		691,
		169
	],
	"./pages/notifications/Page.vue": [
		841,
		32
	],
	"./pages/notifications/components/Sidebar.vue": [
		692,
		168
	],
	"./pages/notifications/components/SubHeader.vue": [
		693,
		167
	],
	"./pages/overview/Page.vue": [
		842,
		4
	],
	"./pages/overview/components/Sidebar.vue": [
		695,
		166
	],
	"./pages/overview/components/SubHeader.vue": [
		694,
		165
	],
	"./pages/payslips/Page.vue": [
		843,
		21
	],
	"./pages/payslips/components/Sidebar.vue": [
		696,
		76
	],
	"./pages/payslips/components/SubHeader.vue": [
		697,
		164
	],
	"./pages/planning/Page.vue": [
		844,
		1
	],
	"./pages/planning/components/AssignDriver.vue": [
		698,
		63
	],
	"./pages/planning/components/Assigned.vue": [
		703,
		62
	],
	"./pages/planning/components/Availability.vue": [
		705,
		163
	],
	"./pages/planning/components/Calculations.vue": [
		699,
		162
	],
	"./pages/planning/components/Copied.vue": [
		702,
		61
	],
	"./pages/planning/components/Item.vue": [
		642,
		161
	],
	"./pages/planning/components/Placeholder.vue": [
		704,
		60
	],
	"./pages/planning/components/ProjectPopover.vue": [
		707,
		75
	],
	"./pages/planning/components/Sidebar.vue": [
		700,
		160
	],
	"./pages/planning/components/SubHeader.vue": [
		701,
		109
	],
	"./pages/planning/components/Weather.vue": [
		706,
		159
	],
	"./pages/plannings/Page.vue": [
		845,
		25
	],
	"./pages/plannings/components/Sidebar.vue": [
		708,
		108
	],
	"./pages/plannings/components/SubHeader.vue": [
		709,
		158
	],
	"./pages/profile/Page.vue": [
		846,
		31
	],
	"./pages/profile/components/Sidebar.vue": [
		710,
		157
	],
	"./pages/profile/components/SubHeader.vue": [
		711,
		156
	],
	"./pages/projects/Page.vue": [
		847,
		18
	],
	"./pages/projects/components/Sidebar.vue": [
		712,
		107
	],
	"./pages/projects/components/SubHeader.vue": [
		713,
		155
	],
	"./pages/register/Page.vue": [
		848,
		154
	],
	"./pages/reports/Page.vue": [
		849,
		9
	],
	"./pages/reports/components/Item.vue": [
		653,
		106
	],
	"./pages/reports/components/Report.vue": [
		716,
		38
	],
	"./pages/reports/components/Sidebar.vue": [
		715,
		105
	],
	"./pages/reports/components/SubHeader.vue": [
		714,
		104
	],
	"./pages/resources/edit/Page.vue": [
		850,
		24
	],
	"./pages/resources/edit/components/Sidebar.vue": [
		718,
		103
	],
	"./pages/resources/edit/components/SubHeader.vue": [
		717,
		153
	],
	"./pages/resources/overview/Page.vue": [
		851,
		23
	],
	"./pages/resources/overview/components/Sidebar.vue": [
		720,
		102
	],
	"./pages/resources/overview/components/SubHeader.vue": [
		719,
		152
	],
	"./pages/roster/Page.vue": [
		852,
		6
	],
	"./pages/roster/components/Content.vue": [
		721,
		11
	],
	"./pages/roster/components/Day.vue": [
		645,
		13
	],
	"./pages/roster/components/Detail.vue": [
		643,
		74
	],
	"./pages/roster/components/Item.vue": [
		646,
		37
	],
	"./pages/roster/components/Sidebar.vue": [
		722,
		73
	],
	"./pages/roster/components/SubHeader.vue": [
		723,
		72
	],
	"./pages/settings/Page.vue": [
		853,
		68
	],
	"./pages/settings/advanced/Page.vue": [
		854,
		59
	],
	"./pages/settings/advanced/components/SubHeader.vue": [
		724,
		151
	],
	"./pages/settings/availability/Page.vue": [
		855,
		58
	],
	"./pages/settings/availability/components/SubHeader.vue": [
		725,
		150
	],
	"./pages/settings/checkin/Page.vue": [
		856,
		57
	],
	"./pages/settings/checkin/components/SubHeader.vue": [
		726,
		149
	],
	"./pages/settings/contracts/Page.vue": [
		857,
		56
	],
	"./pages/settings/contracts/components/SubHeader.vue": [
		727,
		148
	],
	"./pages/settings/costs/Page.vue": [
		858,
		55
	],
	"./pages/settings/costs/components/SubHeader.vue": [
		728,
		147
	],
	"./pages/settings/duties/Page.vue": [
		859,
		54
	],
	"./pages/settings/duties/components/SubHeader.vue": [
		729,
		146
	],
	"./pages/settings/expenses/Page.vue": [
		860,
		53
	],
	"./pages/settings/expenses/components/SubHeader.vue": [
		730,
		145
	],
	"./pages/settings/general/Page.vue": [
		861,
		52
	],
	"./pages/settings/general/components/SubHeader.vue": [
		731,
		144
	],
	"./pages/settings/holidays/Page.vue": [
		862,
		51
	],
	"./pages/settings/holidays/components/SubHeader.vue": [
		732,
		143
	],
	"./pages/settings/locations/Page.vue": [
		863,
		50
	],
	"./pages/settings/locations/components/SubHeader.vue": [
		733,
		142
	],
	"./pages/settings/premiums/Page.vue": [
		864,
		49
	],
	"./pages/settings/premiums/components/SubHeader.vue": [
		734,
		141
	],
	"./pages/settings/rates/Page.vue": [
		865,
		48
	],
	"./pages/settings/rates/components/SubHeader.vue": [
		735,
		140
	],
	"./pages/settings/shifts/Page.vue": [
		866,
		47
	],
	"./pages/settings/shifts/components/SubHeader.vue": [
		736,
		139
	],
	"./pages/settings/tags/Page.vue": [
		867,
		46
	],
	"./pages/settings/tags/components/SubHeader.vue": [
		737,
		138
	],
	"./pages/setup/Page.vue": [
		868,
		137
	],
	"./pages/statistics/Page.vue": [
		869,
		5
	],
	"./pages/statistics/components/Sidebar.vue": [
		741,
		101
	],
	"./pages/statistics/components/SubHeader.vue": [
		740,
		136
	],
	"./pages/statistics/components/TabDetails.vue": [
		739,
		45
	],
	"./pages/statistics/components/TabOverview.vue": [
		738,
		12
	],
	"./pages/subscription/Page.vue": [
		870,
		30
	],
	"./pages/subscription/components/Sidebar.vue": [
		742,
		135
	],
	"./pages/subscription/components/SubHeader.vue": [
		743,
		134
	],
	"./pages/team/edit/Page.vue": [
		871,
		0
	],
	"./pages/team/edit/components/SubHeader.vue": [
		744,
		133
	],
	"./pages/team/edit/sidebars/absence.vue": [
		758,
		100
	],
	"./pages/team/edit/sidebars/contract.vue": [
		754,
		44
	],
	"./pages/team/edit/sidebars/dossier.vue": [
		756,
		99
	],
	"./pages/team/edit/sidebars/payslips.vue": [
		757,
		98
	],
	"./pages/team/edit/sidebars/profile.vue": [
		752,
		97
	],
	"./pages/team/edit/sidebars/salary.vue": [
		755,
		96
	],
	"./pages/team/edit/sidebars/settings.vue": [
		753,
		95
	],
	"./pages/team/edit/tabs/Absence.vue": [
		751,
		20
	],
	"./pages/team/edit/tabs/Contract.vue": [
		746,
		94
	],
	"./pages/team/edit/tabs/Dossier.vue": [
		749,
		93
	],
	"./pages/team/edit/tabs/Payslips.vue": [
		750,
		92
	],
	"./pages/team/edit/tabs/Profile.vue": [
		745,
		91
	],
	"./pages/team/edit/tabs/Salary.vue": [
		747,
		90
	],
	"./pages/team/edit/tabs/Settings.vue": [
		748,
		89
	],
	"./pages/team/overview/Page.vue": [
		872,
		17
	],
	"./pages/team/overview/components/Sidebar.vue": [
		760,
		88
	],
	"./pages/team/overview/components/SubHeader.vue": [
		759,
		132
	],
	"./pages/today/Page.vue": [
		873,
		8
	],
	"./pages/today/components/Sidebar.vue": [
		762,
		16
	],
	"./pages/today/components/SubHeader.vue": [
		761,
		131
	],
	"./pages/today/components/tab/employees.vue": [
		654,
		130
	],
	"./pages/today/components/tab/locations.vue": [
		655,
		43
	],
	"./pages/welcome/Page.vue": [
		874,
		129
	],
	"./templates/Backend.vue": [
		135
	],
	"./templates/Empty.vue": [
		134
	],
	"./templates/Frontend.vue": [
		138
	],
	"./templates/Invoice.vue": [
		141
	],
	"./templates/Wizard.vue": [
		140
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 458;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/js lazy ^.*\.vue$
// module id = 458
// module chunks = 234